<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';

export default {
  name: 'PartnerZone',
  props: {
    latitude: {
      type: Number,
      default: null,
    },
    longitude: {
      type: Number,
      default: null,
    },
    companyName: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      selectedPosition: null,

      defaultIcon: L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIconRetina,
        shadowUrl: markerShadow,
        iconSize: [20, 31],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [10, 10],
      }),
    };
  },

  mounted() {
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      this.map = L.map('mi_mapa_pzc').setView([this.latitude || 0, this.longitude || 0], 16);

      const osmLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 20,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });

      osmLayer.addTo(this.map);

      this.map.on('click', this.handleMapClick);

      if (this.latitude && this.longitude) {
        this.addMarker([this.latitude, this.longitude]);
      }
    },

    addMarker(position) {
      if (this.currentMarker) {
        this.map.removeLayer(this.currentMarker);
      }

      this.currentMarker = L.marker(position, { icon: this.defaultIcon })
        .addTo(this.map)
        .bindPopup(`${position[0].toFixed(5)}, ${position[1].toFixed(5)}`)
        .openPopup();
    },

    handleMapClick(event) {
      const { lat, lng } = event.latlng;
      this.selectedPosition = { latitude: lat, longitude: lng };

      this.addMarker([lat, lng]);

      // Emit the selected position to parent component
      this.$emit('position-selected', this.selectedPosition);
    },
  }
};
</script>

<template>
  <div id="mi_mapa_pzc" style="cursor: crosshair;"></div>
</template>

<style>
#mi_mapa_pzc {
  width: 100%;
  height: 250px;
  min-height: 200px;
  background-color: #f0f0f0;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;
}
</style>
